/**
 * Krok PIL1 (vada V2 generalky GEN1) — JMENO MAKLERE, NE NAZEV FIRMY.
 *
 * Ucet, ktery vznikne aktivaci kancelare z verejneho webu, dostane
 * `user.name` = nazev firmy (v tu chvili je to jedine jmeno, ktere o
 * registraci vime). Administrace z nej pak slozila pozdrav „Dobré dopoledne,
 * MVe" a avatar „MS" (snimek `GEN1/1-08`).
 *
 * Tenhle modul je JEDNO misto, ktere rozhoduje, jestli se mame na jmeno
 * zeptat. Pozdrav (`dnesek.tsx`) i avatar (`layout.tsx`) ctou tentyz
 * `user.name`, takze jakmile ho clovek jednou zada, spravi se obe mista
 * najednou — zadny druhy vypocet.
 */

/** Pravni formy, podle kterych se pozna NAZEV FIRMY v poli pro jmeno cloveka. */
const COMPANY_FORMS: readonly RegExp[] = [
  /(^|\s)s\.?\s?r\.?\s?o\.?($|\s)/i,
  /(^|\s)a\.?\s?s\.?($|\s)/i,
  /(^|\s)spol\.?($|\s)/i,
  /(^|\s)v\.?\s?o\.?\s?s\.?($|\s)/i,
  /(^|\s)k\.?\s?s\.?($|\s)/i,
  /(^|\s)z\.?\s?s\.?($|\s)/i,
  /(^|\s)o\.?\s?p\.?\s?s\.?($|\s)/i,
  /(^|\s)s\.?\s?e\.?($|\s)/i,
];

function normalize(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

/**
 * Ma se administrace zeptat na jmeno?
 *
 * `true` kdyz je pole prazdne, kdyz se shoduje s nazvem kancelare, nebo kdyz
 * nese pravni formu (kancelar muze mit v REOS jiny nazev nez v ARESu, takze
 * samotna shoda s tenantem nestaci).
 *
 * NIC SE NEHADA ZPATKY: jmeno se z nazvu firmy neodvozuje (z „MV reality
 * s.r.o." zadne jmeno cloveka nevede), jen se na nej zeptame.
 */
export function needsRealName(userName: string, tenantName: string | null): boolean {
  const name = normalize(userName);
  if (name === '') return true;
  const tenant = normalize(tenantName ?? '');
  if (tenant !== '' && name.toLocaleLowerCase('cs') === tenant.toLocaleLowerCase('cs')) return true;
  return COMPANY_FORMS.some((form) => form.test(name));
}
